import { Flex } from 'antd'

import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { BREADCRUMBS } from 'constants/breadcrumb'
import { BoosterProgramOverviewCards } from 'modules/booster-program/overview-cards'
import { BoosterProgramTable } from 'modules/booster-program/program-table'

import './styles.scss'

const BoosterProgram = () => {
  const breadCrumbItems = [BREADCRUMBS.BOOSTER_PROGRAM]

  return (
    <Flex vertical gap={24} className="booster-program">
      <Breadcrumb additionalItems={breadCrumbItems} />

      <div>
        <div className="main-title" style={{ marginBottom: 8 }}>
          Booster Program Management
        </div>
        <div className="main-description">Manage and monitor all booster programs</div>
      </div>

      <BoosterProgramOverviewCards />

      <BoosterProgramTable />
    </Flex>
  )
}

export default BoosterProgram
